const FileType = require('file-type/browser');
const mimetypeTable = {
  'video/mp4': 'MP4',
  'video/quicktime': 'MOV',
  'video/x-msvideo': 'AVI',
  'video/avi': 'AVI',
  'video/vnd.avi': 'AVI',
  'video/x-ms-wmv': 'WMV',
  'video/x-ms-asf': 'WMV',
  'video/x-flv': 'FLV'
};

export async function getFileMime(file) {
  return new Promise((resolve) => {
    var reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async function() {
      let fileType = await FileType.fromBuffer(this.result);
      resolve(fileType);
    };
  });
}

export async function getFileExt(file) {
  let result = await getFileMime(file);
  return mimetypeTable[result.mime];
}
